import { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { getConfig } from '@/config/runtime-config';
import { handleOidcSigninCallback } from '@/services/oidcService';

const OIDC_CALLBACK_LOCK_PREFIX = 'oidc:callback:processed:';

const OidcCallbackPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const callbackKey = `${OIDC_CALLBACK_LOCK_PREFIX}${location.pathname}${location.search}`;

    if (globalThis.sessionStorage.getItem(callbackKey)) {
      return;
    }

    globalThis.sessionStorage.setItem(callbackKey, 'true');

    const processCallback = async () => {
      try {
        const returnPath = await handleOidcSigninCallback(getConfig());
        navigate(returnPath, { replace: true });
      } catch (callbackError) {
        console.error('[OIDC Auth] Sign-in callback failed:', callbackError);
        setError(callbackError instanceof Error ? callbackError.message : 'Sign-in callback failed');
      }
    };

    void processCallback();
  }, [location.pathname, location.search, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={2}
    >
      {!error && <CircularProgress />}
      <Typography color={error ? 'error' : 'textPrimary'}>
        {error || 'Completing sign-in...'}
      </Typography>
    </Box>
  );
};

export default OidcCallbackPage;